import { apiFetch } from "./api";

export interface EmailMessage {
  emailLogId: number;
  kind: string;
  subject: string;
  toEmailAddress: string;
  cc: string | null;
  bcc: string | null;
  fromEmailAddress: string | null;
  htmlBody: string;
  attachmentFileNames: string | null;
  sentAtUtc: string;
  sentSuccessfully: boolean;
  errorMessage: string | null;
}

export interface EmailLogListItem {
  emailLogId: number;
  kind: string;
  subject: string;
  toEmailAddress: string;
  relatedEntityType: string | null;
  relatedEntityId: number | null;
  sentAtUtc: string;
  sentSuccessfully: boolean;
}

export const emailLogApi = {
  get: (id: number) => apiFetch<EmailMessage>(`/api/email-log/${id}`),
  list: (params: { q?: string; succeeded?: boolean; page?: number; pageSize?: number }) => {
    const qs = new URLSearchParams();
    if (params.q) qs.set("q", params.q);
    if (params.succeeded !== undefined) qs.set("succeeded", String(params.succeeded));
    qs.set("page", String(params.page ?? 0));
    qs.set("pageSize", String(params.pageSize ?? 50));
    return apiFetch<{ items: EmailLogListItem[]; total: number }>(`/api/admin/email-log?${qs.toString()}`);
  },
  resend: (id: number) => apiFetch<void>(`/api/admin/email-log/${id}/resend`, { method: "POST" }),
};
